import DeskConfirm from "@/components/crm/DeskConfirm";

const FILE_META = { pdf: ["#DC2626", "PDF"], doc: ["#2563EB", "DOC"], docx: ["#2563EB", "DOCX"], xls: ["#16A34A", "XLS"], xlsx: ["#16A34A", "XLSX"], png: ["#8B5CF6", "IMG"], jpg: ["#8B5CF6", "IMG"], jpeg: ["#8B5CF6", "IMG"], webp: ["#8B5CF6", "IMG"] };
const metaOf = (fn = "") => FILE_META[(String(fn).toLowerCase().match(/\.([a-z0-9]+)$/) || [])[1]] || ["#9CA3AF", "FILE"];

/** Confirmation de suppression d'un fichier — R2 (iter393). */
export default function ConfirmDeleteFileDialog({ open, onOpenChange, filename, onConfirm, busy = false, title = "Supprimer ce fichier ?" }) {
  const [color, label] = metaOf(filename);
  return (
    <DeskConfirm open={open} title={title} busy={busy} confirmLabel={busy ? "Suppression…" : "Supprimer"} message="Cette action est irréversible."
      onClose={() => { if (!busy) onOpenChange(false); }} onConfirm={onConfirm} testId="confirm-delete-file-dialog">
      <div className="flex items-center" style={{ gap: 10, padding: "8px 10px", borderRadius: 8, background: "#111114", border: "0.5px solid #2a2a30" }} data-testid="confirm-delete-file-block">
        <span className="inline-flex items-center justify-center shrink-0" style={{ width: 30, height: 30, borderRadius: 7, fontSize: 9, fontWeight: 700, color, border: `1px solid ${color}55`, background: `${color}1f` }}>{label}</span>
        <span className="truncate" style={{ fontSize: 12, color: "#E8E8EC" }} title={filename} data-testid="confirm-delete-file-name">{filename || "Fichier"}</span>
      </div>
    </DeskConfirm>
  );
}
